<template>
  <div>
    <el-table
      :data="tableData"
      :height="$attrs.height - 30"
      :span-method="objectSpanMethod"
      @selection-change="onPreviewTableSelectionChange"
      border
      class="preview-table common-el-table-styles"
      style="width: 100%"
    >
      <el-table-column fixed="left" type="selection"> </el-table-column>

      <el-table-column fixed="left" label="序号" width="50">
        <template slot-scope="{ row }">
          <span>{{ row.adIndex }}</span>
        </template>
      </el-table-column>

      <el-table-column fixed="left" label="计划" min-width="310">
        <template slot="header" slot-scope="scope">
          <div :class="scope.a" class="custom-column-header">
            <div>
              <span>&ensp;计划</span>
              <!-- 在已有计划下新增创意，不显示动态词 -->
              <DynamicWordsInput
                v-if="!parentInstance.addCreativeFlag"
                title
                @input="onProjectNameInput"
                :el="activeProjectNameInput"
                :words="dynamicWords"
              ></DynamicWordsInput>
            </div>
          </div>
        </template>
        <template slot-scope="{ row, $index }">
          <!-- 在已有计划下新增创意，不可编辑广告计划名 -->
          <el-input
            class="dynamic-words-reference"
            :disabled="parentInstance.addCreativeFlag"
            @focus="onProjectNameInputFocus($event, $index)"
            v-model="row.plan.project_name"
            placeholder="请输入计划"
          ></el-input>
        </template>
      </el-table-column>

      <template v-if="!parentInstance.addCreativeFlag">
        <el-table-column label="计划账号" width="180">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.accountCheck" @change="onGlobalCheckChange($event, 'accountCheck')"></el-checkbox>
                <span>&ensp;计划账号</span>
              </div>
              <span class="col-modify" @click="onAccountModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.accountCheck"> </el-checkbox>
            <span class="row-prop-button" @click.stop="onAccountModify($index)" :title="row.plan.account.name">
              &ensp;{{ row.plan.account.name }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="定向包" width="120">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.targetCheck" @change="onGlobalCheckChange($event, 'targetCheck')"></el-checkbox>
                <span>&ensp;定向包</span>
              </div>
              <span class="col-modify" @click="onTargetModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.targetCheck"> </el-checkbox>
            <span class="row-prop-button" @click="onTargetModify($index)"> &ensp;{{ row.target.name }}</span>
          </template>
        </el-table-column>
      </template>

      <el-table-column label="创意组" width="120">
        <template slot="header" slot-scope="scope">
          <div :class="scope.a" class="custom-column-header">
            <div>
              <el-checkbox v-model="tableHeaderForm.creativeCheck" @change="onGlobalCheckChange($event, 'creativeCheck')"></el-checkbox>
              <span>&ensp;创意组</span>
            </div>
            <span class="col-modify" @click="onCreativeModify()">
              <i class="el-icon-edit"></i>
              修改
            </span>
          </div>
        </template>

        <template slot-scope="{ row, $index }">
          <el-checkbox v-model="row.creativeCheck"> </el-checkbox>
          <span class="row-prop-button" @click="onCreativeModify($index)"> &ensp;{{ row.creative.groupName }}</span>
        </template>
      </el-table-column>

      <template v-if="!parentInstance.addCreativeFlag">
        <el-table-column label="日预算" width="160">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox
                  v-model="tableHeaderForm.dailyBudgetCheck"
                  @change="onGlobalCheckChange($event, 'dailyBudgetCheck')"
                ></el-checkbox>
                <span>&ensp;日预算</span>
              </div>
              <span class="col-modify" @click="onBudgetModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.dailyBudgetCheck"> </el-checkbox>
            <el-radio-group style="margin-left: 10px" class="radio-group" v-model="row.bid.budget">
              <div>
                <el-radio :label="0">不限</el-radio>
              </div>
              <div>
                <el-radio :label="1">
                  <el-button @click="onBudgetModify($index)" :disabled="row.bid.budget === 0" type="text">
                    {{ row.bid.daily_budget ? `日预算：${row.bid.daily_budget}` : '未设置日预算' }}
                  </el-button>
                </el-radio>
              </div>
            </el-radio-group>
          </template>
        </el-table-column>

        <el-table-column label="总预算" width="160">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox
                  v-model="tableHeaderForm.totalBudgetCheck"
                  @change="onGlobalCheckChange($event, 'totalBudgetCheck')"
                ></el-checkbox>
                <span>&ensp;总预算</span>
              </div>
              <span class="col-modify" @click="onTotalBudgetModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.totalBudgetCheck"> </el-checkbox>
            <el-radio-group style="margin-left: 10px" class="radio-group" v-model="row.bid.totalBudget">
              <div>
                <el-radio :label="0">不限</el-radio>
              </div>
              <div>
                <el-radio :label="1">
                  <el-button @click="onTotalBudgetModify($index)" :disabled="row.bid.totalBudget === 0" type="text">
                    {{ row.bid.total_budget ? `总预算：${row.bid.total_budget}` : '未设置总预算' }}
                  </el-button>
                </el-radio>
              </div>
            </el-radio-group>
          </template>
        </el-table-column>

        <el-table-column label="转化归因" width="140">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.convertCheck" @change="onGlobalCheckChange($event, 'convertCheck')"></el-checkbox>
                <span>&ensp;转化归因</span>
              </div>
              <span class="col-modify" @click="onConvertModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ $index, row }">
            <el-checkbox v-model="row.convertCheck"> </el-checkbox>
            <el-button @click="onConvertModify($index)" type="text">转化归因</el-button>
          </template>
        </el-table-column>

        <el-table-column label="人群包（选填）" width="180">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox
                  v-model="tableHeaderForm.populationCheck"
                  @change="onGlobalCheckChange($event, 'populationCheck')"
                ></el-checkbox>
                <span>&ensp;人群包（选填）</span>
              </div>
              <span class="col-modify" @click="onPopModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.populationCheck"> </el-checkbox>
            <el-button @click="onPopModify($index)" v-if="hasPops(row)" type="text"> 已配置人群包 </el-button>
            <el-button @click="onPopModify($index)" v-else type="text">未配置人群包</el-button>
          </template>
        </el-table-column>
      </template>

      <el-table-column v-if="showProfileCol" label="品牌形象跳转" min-width="220">
        <template slot="header" slot-scope="scope">
          <div :class="scope.a" class="custom-column-header">
            <div>
              <el-checkbox v-model="tableHeaderForm.profileCheck" @change="onGlobalCheckChange($event, 'profileCheck')"></el-checkbox>
              <span>&ensp;品牌形象跳转</span>
            </div>
            <span class="col-modify" @click="onProfileModify()">
              <i class="el-icon-edit"></i>
              修改
            </span>
          </div>
        </template>

        <template slot-scope="{ row, $index }">
          <el-checkbox v-model="row.profileCheck"> </el-checkbox>
          <span class="row-prop-button" @click="onProfileModify($index)">
            <span v-if="pageStates.isV3"> {{ getV3ProfileName(row) }}</span>
            <span v-else> {{ getADAProfileName(row) }} </span>
          </span>
        </template>
      </el-table-column>

      <el-table-column v-if="pageStates.isV3" label="落地页" min-width="140">
        <template slot="header" slot-scope="scope">
          <div :class="scope.a" class="custom-column-header">
            <div>
              <el-checkbox v-model="tableHeaderForm.pagesV3Check" @change="onGlobalCheckChange($event, 'pagesV3Check')"></el-checkbox>
              <span>&ensp;落地页</span>
            </div>
            <span class="col-modify" @click="onPagesV3Modify()">
              <i class="el-icon-edit"></i>
              修改
            </span>
          </div>
        </template>

        <template slot-scope="{ row, $index }">
          <el-checkbox v-model="row.pagesV3Check"> </el-checkbox>
          <span class="row-prop-button" @click="onPagesV3Modify($index)">
            {{ row.creative.pageInfo && row.creative.pageInfo.length ? '已配置落地页' : '未配置落地页' }}
          </span>
        </template>
      </el-table-column>

      <el-table-column v-else label="落地页" min-width="140">
        <template slot="header" slot-scope="scope">
          <div :class="scope.a" class="custom-column-header">
            <div>
              <el-checkbox v-model="tableHeaderForm.pagesCheck" @change="onGlobalCheckChange($event, 'pagesCheck')"></el-checkbox>
              <span>&ensp;落地页</span>
            </div>
            <span class="col-modify" @click="onPagesModify()">
              <i class="el-icon-edit"></i>
              修改
            </span>
          </div>
        </template>

        <template slot-scope="{ row, $index }">
          <el-checkbox v-model="row.pagesCheck"> </el-checkbox>
          <span class="row-prop-button" @click="onPagesModify($index)">
            {{ row.creative.pageInfo ? row.creative.pageInfo.page_spec.page_name : '未配置落地页' }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80">
        <template slot-scope="{ row, $index }">
          <el-button v-if="pageStates.isADA" type="text" @click="onPlanRowDuplicate(row, $index)">复制</el-button>
          <el-button type="text" @click="onPlanRowRemove(row, $index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <AdAccountModifyModal
      title="选择计划账号"
      :visible.sync="modal.showGlobalAccountModify"
      @confirm="onAccountModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdAccountModifyModal>

    <AdTargetModifyModal
      title="选择定向包"
      :visible.sync="modal.showGlobalTargetModify"
      @confirm="onTargetModifyConfirm"
      @cancel="onModifyModalCancel"
    >
    </AdTargetModifyModal>

    <AdCreativeModifyModal
      title="选择创意组"
      :visible.sync="modal.showGlobalCreativeModify"
      @confirm="onCreativeModifyConfirm"
      @cancel="onModifyModalCancel"
    >
    </AdCreativeModifyModal>

    <AdBudgetModifyModal
      title="修改日预算"
      :visible.sync="modal.showGlobalBudgetModify"
      :current-row="currentModifyTableRow"
      @confirm="onBudgetModifyConfirm"
      @cancel="onModifyModalCancel"
    >
    </AdBudgetModifyModal>

    <AdBudgetModifyModal
      title="修改总预算"
      :visible.sync="modal.showGlobalTotalBudgetModify"
      @confirm="onTotalBudgetModifyConfirm"
      @cancel="onModifyModalCancel"
    >
    </AdBudgetModifyModal>

    <AdBidModifyModal
      title="修改出价"
      :visible.sync="modal.showGlobalBidModify"
      @confirm="onBidModifyConfirm"
      @cancel="onModifyModalCancel"
    >
    </AdBidModifyModal>

    <AdConvertModifyModal
      title="修改转化"
      width="870px"
      :visible.sync="modal.showGlobalConvertModify"
      :current-row="currentModifyTableRow"
      @confirm="onConvertModifyConfirm"
      @cancel="onModifyModalCancel"
    >
    </AdConvertModifyModal>

    <AdPopulationModifyModal
      title="修改人群包"
      :visible.sync="modal.showGlobalPopModify"
      :current-row="currentModifyTableRow"
      @confirm="onPopModifyConfirm"
      @cancel="onModifyModalCancel"
    >
    </AdPopulationModifyModal>

    <AdPagesModifyModal
      title="修改落地页"
      :visible.sync="modal.showGlobalPagesModify"
      @confirm="onPagesModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdPagesModifyModal>

    <!-- 腾讯广告3.0落地页选择 -->
    <AdPagesV3ModifyModal
      title="落地页跳转"
      :visible.sync="modal.showGlobalPagesV3Modify"
      :current-row="currentModifyTableRow"
      @confirm="onPagesV3ModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdPagesV3ModifyModal>

    <AdProfileModifyModal
      :visible.sync="modal.showGlobalProfileModify"
      :is-channels="parentInstance.isChannels"
      :current-row="currentModifyTableRow"
      @confirm="onProfileModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdProfileModifyModal>
  </div>
</template>
<script>
import { clone } from '@/common/js/just.js'
import AdAccountModifyModal from './components/ad-account.vue'
import AdTargetModifyModal from './components/ad-target.vue'
import AdCreativeModifyModal from './components/ad-creative.vue'
import AdBudgetModifyModal from './components/ad-budget.vue'
import AdBidModifyModal from './components/ad-bid.vue'
import AdConvertModifyModal from './components/ad-convert2.vue'
import AdPopulationModifyModal from './components/ad-population.vue'
import AdPagesModifyModal from './components/ad-langingpage.vue'
import AdPagesV3ModifyModal from './components/ad-langingpage-v3.vue'
import AdProfileModifyModal from './components/ad-profile.vue'
import { projectComputedMethods } from '@/views/create/gdt/model/project-mixins.js'

import DynamicWordsInput from '@/components/dynamic-words-input'
import { ADA_DYNAMIC_WORDS, V3_DYNAMIC_WORDS } from '@/views/create/gdt/model/project-const.js'
import { BID_SCENE, DEEP_CONVERSION_TYPE } from '@/views/create/gdt/model/budget/budget-const.js'

import { getDefaultCheckStates, getDefaultModalStates } from '@/views/create/gdt/model/distribute-form.js'

import { onAccountModify, onAccountModifyConfirm } from './methods/modify-account.js'
import { onTargetModify, onTargetModifyConfirm } from './methods/modify-target.js'
import { onCreativeModify, onCreativeModifyConfirm } from './methods/modify-creative.js'
import { onBudgetModify, onBudgetModifyConfirm } from './methods/modify-budget.js'
import { onTotalBudgetModify, onTotalBudgetModifyConfirm } from './methods/modify-total-budget.js'
import { onBidModify, onBidModifyConfirm } from './methods/modify-bid.js'
import { onConvertModify, onConvertModifyConfirm } from './methods/modify-convert.js'
import { onPopModify, onPopModifyConfirm } from './methods/modify-population.js'
import { onPagesModify, onPagesModifyConfirm, onPagesV3Modify, onPagesV3ModifyConfirm } from './methods/modify-pages.js'
import { onProfileModify, onProfileModifyConfirm } from './methods/modify-profile.js'

let increasePlanProjectNameIndex = 0
export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    selections: {
      type: Array
    },
    objectSpanMethod: {
      type: Function,
      default: () => {}
    }
  },
  inject: ['parentInstance'],
  provide() {
    return {
      previewTable: this
    }
  },
  components: {
    DynamicWordsInput,
    AdAccountModifyModal,
    AdTargetModifyModal,
    AdCreativeModifyModal,
    AdBudgetModifyModal,
    AdBidModifyModal,
    AdConvertModifyModal,
    AdPopulationModifyModal,
    AdPagesModifyModal,
    AdPagesV3ModifyModal,
    AdProfileModifyModal
  },

  data() {
    return {
      DEEP_CONVERSION_TYPE,
      modal: getDefaultModalStates(),
      // 表头checkbox model
      tableHeaderForm: getDefaultCheckStates(),
      // 保存当前修改行
      currentModifyTableRow: null,
      // 最后获得焦点的项目名称input元素，用于插入动态名称
      activeProjectNameInput: null,
      activeProjectNameRowIndex: 0
    }
  },
  computed: {
    dynamicWords() {
      return this.pageStates.isV3 ? V3_DYNAMIC_WORDS : ADA_DYNAMIC_WORDS
    },
    // pageStates
    ...projectComputedMethods,
    tableData: {
      get() {
        return this.data
      },
      set(data) {
        this.$emit('update:data', data)
      }
    },
    showConversionCol() {
      const [row] = this.tableData
      // 最大转化出价不显示出价列
      if (row.bid.bid_scene === BID_SCENE.NORMAL_MAX) return false
      return true
    },

    showProfileCol() {
      const { isADA } = this.pageStates
      // ada 包含朋友圈版位时显示；
      if (isADA) {
        return this.parentInstance.hasMoment
      }

      // v3 显示；
      return true
    }
  },
  methods: {
    /**
     * @description: 修改账号
     */
    onAccountModify,
    onAccountModifyConfirm,

    /**
     * @description: 修改定向包
     */
    onTargetModify,
    onTargetModifyConfirm,

    /**
     * @description: 修改创意组
     */

    onCreativeModify,
    onCreativeModifyConfirm,

    /**
     * @description: 修改日预算
     */

    onBudgetModify,
    onBudgetModifyConfirm,

    /**
     * @description: 修改总预算
     */

    onTotalBudgetModify,
    onTotalBudgetModifyConfirm,

    /**
     * @description: 修改出价
     */

    onBidModify,
    onBidModifyConfirm,

    /**
     * @description: 修改转化
     * @return {*}
     */

    onConvertModify,
    onConvertModifyConfirm,

    /**
     * @description: 人群包修改
     * @return {*}
     */

    onPopModify,
    onPopModifyConfirm,

    /**
     * @description: 落地页修改
     * @return {*}
     */

    onPagesModify,
    onPagesModifyConfirm,

    /**
     * @description: 腾讯广告3.0落地页跳转
     * @return {*}
     */
    onPagesV3Modify,
    onPagesV3ModifyConfirm,

    /**
     * @description: 头像昵称修改、品牌形象跳转
     * @return {*}
     */

    onProfileModify,
    onProfileModifyConfirm,

    onPreviewTableSelectionChange(rows) {
      this.$emit('update:selections', rows)
    },

    getV3ProfileName(row) {
      const { brandInfo, profileInfo } = row.creative.components.brand || {}
      const { channelInfo } = row.creative.components.wechat_channels || {}
      const { brand_id, name } = brandInfo || {}
      const { profile_id, profile_name } = profileInfo || {}
      const { promoted_object_id, promoted_object_name } = channelInfo || {}

      if (brand_id) {
        return `品牌形象：${name}`
      }

      if (profile_id) {
        return `品牌简介页：${profile_name}`
      }

      if (promoted_object_id) {
        return `视频号：${promoted_object_name}`
      }
      return '未配置品牌形象跳转'
    },
    getADAProfileName(row) {
      return row.creative.profile?.profile_name ? row.creative.profile.profile_name : '未配置品牌形象跳转'
    },

    hasPops(row) {
      const { populations } = row.target
      if (populations) {
        const { includes, excludes } = populations[row.plan.account.id]
        return includes?.length || excludes?.length
      }
      return false
    },

    /**
     * @description: 列全选、取消全选
     * @param {Boolean} isCheckAll 全选与取消全选
     * @param {String} prop 列名
     */
    onGlobalCheckChange(isCheckAll, prop) {
      const tableData = this.tableData.map((row) => {
        return { ...row, [prop]: isCheckAll }
      })
      this.tableData = tableData
    },

    /**
     * @description: 关闭列编辑弹窗
     */
    onModifyModalCancel() {
      this.modal = getDefaultModalStates()
      this.$nextTick(() => {
        this.resetModifyForm()
      })
    },

    /**
     * @description: 重置数据
     * @return {*}
     */
    resetModifyForm() {
      this.currentModifyTableRow = null
      // 重置表头勾选状态
      this.tableHeaderForm = getDefaultCheckStates()
      // 重置行勾选状态
      this.tableData = this.tableData.map((row) => {
        return {
          ...row,
          // 取消行勾选
          ...getDefaultCheckStates()
        }
      })
    },
    /**
     * @description: 更新插入动态词后项目名称
     * @param {*} name
     */
    onProjectNameInput(name) {
      const newTableData = [...this.tableData]
      newTableData[this.activeProjectNameRowIndex].plan.project_name = name
      this.tableData = newTableData
    },
    /**
     * @description: 保存当前项目名称的input，用于动态词插入
     * @param {*} e
     * @param {*} rowIndex
     */
    onProjectNameInputFocus(e, rowIndex) {
      this.activeProjectNameInput = e.target
      this.activeProjectNameRowIndex = rowIndex
    },

    /**
     * @description: 批量复制，被当前组件、也被父级组件调用
     * @param {*} rows
     * @param {*} index
     */
    onMultipleRowsDuplicate(rows, index) {
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i]
        row.plan.project_name += `_${++increasePlanProjectNameIndex}`
      }

      const newTableData = [...this.tableData]
      index = index + 1
      newTableData.splice(index, 0, ...rows)
      this.tableData = newTableData
    },

    /**
     * @description: 单行复制
     * @param {*} row
     * @param {*} index
     */
    onPlanRowDuplicate(row, index) {
      row = clone(row)
      this.onMultipleRowsDuplicate([row], index)
    },
    onPlanRowRemove(row, index) {
      const newTableData = [...this.tableData]
      newTableData.splice(index, 1)
      this.tableData = newTableData
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';
.custom-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .col-modify {
    cursor: pointer;
  }
}
::v-deep .preview-table {
  &.el-table thead th .cell {
    height: 38px;
    // line-height: 34px;
  }
  .radio-group {
    .el-radio__label {
      font-size: 12px;
    }
  }

  // 设置主颜色，且可点击状态，不能用el-button
  .row-prop-button {
    color: $primary-color;
    cursor: pointer;
  }
  .bid-cell {
    display: flex;
    align-items: center;
  }
}
</style>
